// Finds special characters that are not A-Z, a-z, 0-9, "-", "_", ".", " ", or ä, ö, ü
// like (, ), *, <, >, :, /, \, @, and so on. Blob storage can't handle not allowed characters.
export const disallowedCharactersRegex = /[^A-Za-z0-9\-_äöü. ]/g

// Valid email
export const emailRegex =
  /^[a-zA-Z0-9._%+-]+[a-zA-Z0-9]+@[a-zA-Z0-9]+[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

// Valid supplier id
// A-Z, a-z, 0-9 with a min 1 and max 25 characters
export const supplierIdRegex = /^[a-zA-Z0-9_]{1,25}$/
